<div class="host-page" [ngClass]="{'clsWrapping': !isMobileView, 'clsWrappingMobile': isMobileView}" style="margin-bottom: 130px;">
<!-- <app-spinner [show]="showSpinner" [size]="150"> </app-spinner> -->
<div *ngIf="applicationSubmitted" class="host-success">
  <div class="host-success__card">
    <p class="host-kicker">Application received</p>
    <h1 class="host-heading">{{ successHeadline }}</h1>
    <p class="host-success__lead">You're one step closer to hosting on LootLucky and starting to earn.</p>
    <p class="host-success__copy">
      {{ successBody }}
    </p>
    <div class="host-success__id">
      <span>Your request ID</span>
      <strong>{{ submittedRequestId }}</strong>
    </div>
    <p class="host-success__note">Hang onto this ID. We'll review your application within 24 hours and email you as soon as you're cleared to go live.</p>
  </div>
</div>
<div *ngIf="!applicationSubmitted">
  <header class="host-hero">
    <p class="host-kicker">Become a host</p>
    <h1 class="host-heading">Host application</h1>
    <p class="host-sub">A few details about your business. We review every application before opening the Host Portal.</p>
  </header>
  <mat-horizontal-stepper [linear]="true" #stepper class="host-stepper">
    <mat-step [hasError]="(personalDetails.invalid || businessImageValidate) && personal_step" [stepControl]="personalDetails">
      <ng-template matStepLabel>
        <span [class.step-invalid]="(personalDetails.invalid || businessImageValidate) && personal_step">Personal Details</span>
      </ng-template>
      <div [formGroup]="personalDetails">
        <div class="container" style="padding-top: 20px;" *ngIf="step == 1">
          <div class="row">
            <div class="col-sm-12 col-md-8 col-lg-8" style="padding-right: 20px;">
              <div class="row">
                <!-- HasBusiness select removed and replaced with a hidden control -->
                <input type="hidden" formControlName="HasBusiness" />
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <mat-form-field class="clsGapping">
                    <mat-label>First Name </mat-label>
                    <input matInput type="text" formControlName="FirstName" required readonly>
                    <mat-error *ngIf="getFirstName.errors?.required">First Name Required</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <mat-form-field class="clsGapping">
                    <mat-label>Last Name: </mat-label>
                    <input matInput type="text" formControlName="LastName" required readonly>
                    <mat-error *ngIf="getLastName.errors?.required">Last Name required</mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <mat-form-field class="clsGapping">
                    <mat-label>Cell Phone </mat-label>
                    <input matInput formControlName="CellNumber" required maxlength="10" minlength="10" phoneNumberChecker>
                    <mat-error *ngIf="getCellNumber.errors?.required">Enter Valid Cell Number</mat-error>
                    <mat-error *ngIf="personalDetails.controls.CellNumber.hasError('minlength')">Allowed length is 10 digits (without country code).</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <mat-form-field class="clsGapping">
                    <mat-label>Email </mat-label>
                    <input matInput type="text" formControlName="Email" required readonly>
                    <mat-error *ngIf="getEmail.errors?.required">Email id is required</mat-error>
                    <mat-error *ngIf="getEmail.errors?.email">Provide valid Email.</mat-error>
                  </mat-form-field>
                </div>
              </div> 

              <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <mat-form-field class="clsGapping">
                    <mat-label>Preferred Room Name</mat-label>
                    <input matInput type="text" formControlName="PrefferedRooName" required>
                    <mat-error *ngIf="getPrefferedRooName.errors?.required">Preferred Room Name is required</mat-error>
                  </mat-form-field>
                </div>
              </div>

              <!-- New row: SSN and TaxId side-by-side -->
              <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <mat-form-field class="clsGapping">
                    <mat-label>SSN</mat-label>
                    <input matInput type="text" formControlName="SSN" maxlength="11" placeholder="XXX-XX-XXXX" appFormatSsn>
                  </mat-form-field>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <mat-form-field class="clsGapping">
                    <mat-label>Tax Id</mat-label>
                    <input matInput type="text" formControlName="TaxId" placeholder="XXX-XXXXXX" appFormatTaxId>
                  </mat-form-field>
                </div>
              </div>
              <div class="row" style="margin-bottom: 10px; margin-left: 10px;">
                <div class="col-12">
                  <small class="host-field-note">Note: Either SSN or Tax ID is required. Please provide at least one.</small>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <mat-error *ngIf="taxSsnValidate">Please provide either Tax ID or SSN</mat-error>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <!-- OnlineSeller select hidden as requested; value defaulted to true in component -->
                  <input type="hidden" formControlName="OnlineSeller" />
                </div>
              </div>

              <div>
                <div class="row" *ngIf="!getOnlineSeller.value">
                  <mat-form-field class="clsGapping">
                    <mat-label>Explanation </mat-label>
                    <textarea matInput type="text" formControlName="ExplanationText"></textarea>
                    <mat-error *ngIf="getExplanationText.errors?.required">Please enter max 4000 characters</mat-error>
                  </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-4 col-lg-4" style="padding-right: 20px;" *ngIf="isMobileView">
                  <ng-container *ngTemplateOutlet="businessPhotoUpload"></ng-container>
                </div>

                <div class="row align-right-end" style="margin-bottom: 10px;">
                  <div class="col-md-12">
                    <button class="host-cta" type="button" (click)="stepper.next()">Next</button>
                  </div>
                </div>
              </div> 
              
              <div *ngIf="!getHasBusiness && getHasBusiness != ''">
                <div class="row">
                  <div class="col-sm-12 col-md-12 col-lg-12">
                    <mat-error>Please come back once you create a Business</mat-error>
                  </div>
                </div>          
              </div>

            </div>
          <div class="col-sm-12 col-md-4 col-lg-4" style="padding-right: 20px;" *ngIf="!isMobileView">
            <ng-container *ngTemplateOutlet="businessPhotoUpload"></ng-container>
          </div>
        </div>
      </div>
    </div>
</mat-step>
    <mat-step [stepControl]="businessDetails" [hasError]="businessDetails.invalid && business_step">
      <ng-template matStepLabel>
        <span [class.step-invalid]="businessDetails.invalid && business_step">Business Details</span>
      </ng-template>
      <div [formGroup]="businessDetails">
        <div class="container" style="padding-top: 20px;">
          <div class="row">
            <div class="col-sm-12 col-md-10 col-lg-10" style="padding-right: 20px;">
              <div *ngIf="getHasBusiness">
                <div class="row">
                  <div class="col-sm-12 col-md-6 col-lg-6">
                    <mat-form-field class="clsGapping">
                      <mat-label>Business Name </mat-label>
                      <input matInput type="text" formControlName="BusinessName">
                      <mat-error *ngIf="getBusinessName.errors?.required">Enter Valid business name</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-6">
                    <mat-form-field class="clsGapping">
                      <mat-label>Business DBA </mat-label>
                      <input matInput type="text" formControlName="BusinessDBA">
                      <mat-error *ngIf="getBusinessDBA.errors?.required">Enter valid business DBA</mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 col-md-6 col-lg-6">
                    <mat-form-field class="clsGapping">
                      <mat-label>Business Address </mat-label>
                      <input matInput type="text" formControlName="BusinessAddress">
                      <mat-error *ngIf="getBusinessAddress.errors?.required">Enter Valid business address</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-6">
                    <mat-form-field class="clsGapping">
                      <mat-label>Business Phone </mat-label>
                      <input matInput type="text" formControlName="BusinessPhone" phoneNumberChecker minlength="10" maxlength="10">
                      <mat-error *ngIf="getBusinessPhone.errors?.minlength">Allowed length is 10 digits (without country code)</mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 col-md-6 col-lg-6">
                    <mat-form-field class="clsGapping">
                      <mat-label>Company Name </mat-label>
                      <input matInput type="text" formControlName="companyName">
                      <mat-error *ngIf="getCompanyName.errors?.required">Enter Valid company name</mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row align-right-end">
                  <div class="col-sm-12 col-md-12 col-l-12">
                    <button class="host-cta host-cta--ghost" type="button" (click)="stepper.previous()">Previous</button>
                    <button class="host-cta" type="button" (click)="stepper.next()">Next</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-step>

    <mat-step [stepControl]="marketDetails" [hasError]="marketDetails.invalid && market_step">
      <ng-template matStepLabel>
        <span [class.step-invalid]="marketDetails.invalid && market_step">Market Details</span>
      </ng-template>
      <div [formGroup]="marketDetails">
        <div class="container" style="padding-top: 20px;">
          <div class="row">
            <div class="col-sm-12 col-md-8 col-lg-8" style="padding-right: 20px;">
              <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <mat-form-field class="clsGapping">
                    <mat-label>How do you currently sell to your customer base? </mat-label>
                    <input matInput type="text" formControlName="CustomerBase">
                    <mat-error *ngIf="getCustomerBase.errors?.required">Enter Valid Customer Base</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <mat-form-field class="clsGapping">
                    <mat-label>Years in business </mat-label>
                    <mat-select formControlName="YearsOfBusiness" placeholder="Years in Business">
                      <mat-option>None</mat-option>
                      <mat-option *ngFor="let years of yearsInBussinessOption" [value]="years">{{years.name}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="getYearsOfBusiness.errors?.required">Enter valid Years Of Business</mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <mat-form-field class="clsGapping">
                    <mat-label>Online Rating Company </mat-label>
                    <mat-select formControlName="OnlineRatingCompany" placeholder="Online Rating Company">
                      <mat-option>None</mat-option>
                      <mat-option *ngFor="let company of onlineRatingCompanyOptions" [value]="company">{{company.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="getOnlineRatingCompany.errors?.required">Enter Valid Online Rating Company</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <mat-form-field class="clsGapping">
                    <mat-label>Online Rating Score </mat-label>
                    <input matInput type="text" formControlName="OnlineRatingScore" (keypress)="onlyIntegerOneToTenAllowed($event)" maxlength="2">
                    <mat-error *ngIf="getOnlineRatingScore.errors?.required">Enter valid Online Rating Score</mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <mat-form-field class="clsGapping">
                    <mat-label>Primary Item Of Sale </mat-label>
                    <mat-select formControlName="PrimaryItemOfSale" placeholder="Primary Item Of Sale">
                      <mat-option>None</mat-option>
                      <mat-option *ngFor="let item of itemPlanToHost" [value]="item">{{item.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="getPrimaryItemOfSale.errors?.required">Enter Valid Primary Item Of Sale</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <mat-form-field class="clsGapping">
                    <mat-label>Secondary Item Of Sale </mat-label>
                    <mat-select formControlName="SecondryItemOfSale" placeholder="Secondary Item Of Sale">
                      <mat-option>None</mat-option>
                      <mat-option *ngFor="let item of itemPlanToHost" [value]="item">{{item.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="getSecondryItemOfSale.errors?.required">Enter valid Secondary Item Of Sale</mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <mat-form-field class="clsGapping">
                    <mat-label>How many subscribers do you expect to bring with you to <span style="word-break: keep-all;white-space: nowrap;">W-O-W.?</span> </mat-label>
                    <mat-select formControlName="NumberOfSubscriber" placeholder="Number Of Subscriber">
                      <mat-option>None</mat-option>
                      <mat-option *ngFor="let subscriber of noOfSubscriber" [value]="subscriber">{{subscriber.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="getNumberOfSubscriber.errors?.required">Enter Valid number of subscriber</mat-error>
                  </mat-form-field>
                </div>


                <div class="col-sm-12" style="padding-right: 20px;" *ngIf="EnableFFLImage() && isMobileView">
                  <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-12"> 
                      <div [ngClass]="{'uploadImgWeb': !isMobileView, 'uploadImgMobile': isMobileView}">
                        <a href="javascript:void(0)" (click)="file.click()">
                          <i class="fa fa-upload"></i> Upload your current FFL
                        </a>
                        <input  type="file" #file (change)="preview($event ,'fflImage')" style="display:none" />
                        <mat-error *ngIf="fflImageValidate">FFL Image is mandatory</mat-error>
                      </div>
                   
                    </div>
                  </div> 
                  <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-12">
                      <span class="host-field-note">Please note that FFL image is valid for only 2 Years.</span>
                    </div>
                  </div>
                  <div class="row carousel-image" *ngIf="fflImage">
                    <div class="col-md-12" style="padding-top:16px">
                       <img [src]="fflImage.image" class="d-block" alt="FFL Image" style="max-width: 350px;max-height: 400px;">   
                    </div>
                  </div> 
                </div>


              </div>
              <div class="row align-right-end">
                <div class="col-sm-12 col-md-12 col-lg-12">
                    <button class="host-cta host-cta--ghost" type="button" (click)="stepper.previous()">Previous</button>
                    <button class="host-cta" type="button" (click)="stepper.next()">Next</button>
                </div>
              </div>
            </div> 
            <div class="col-md-4" style="padding-right: 20px;" *ngIf="EnableFFLImage() && !isMobileView">
              <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12"> 
                  <div [ngClass]="{'uploadImgWeb': !isMobileView, 'uploadImgMobile': isMobileView}">
                    <a href="javascript:void(0)" (click)="file.click()">
                      <i class="fa fa-upload"></i> Upload your current FFL
                    </a>
                    <input  type="file" #file (change)="preview($event ,'fflImage')" style="display:none" />
                  </div>
               
                </div>
              </div> 
              <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12">
                  <span style="font-style: italic;color: #b7410e;"> Please note that FFL image is valid for only 2 Years.</span>
                </div>
              </div>
              <div class="row carousel-image">
                <mat-error *ngIf="fflImageValidate">FFL Image is mandetory</mat-error>
                <div class="col-md-12" style="padding-top:16px" *ngIf="fflImage">
                   <img [src]="fflImage.image" class="d-block" alt="FFL Image" style="max-width: 350px;max-height: 400px;">   
                </div>
              </div> 
            </div>

          </div>
        </div>
      </div>
    </mat-step>

    <mat-step [stepControl]="consentDetails" [hasError]="consentDetails.invalid && consent_step">
      <ng-template matStepLabel>
        <span [class.step-invalid]="consentDetails.invalid && consent_step">Consents & Submit</span>
      </ng-template>
      <div [formGroup]="consentDetails">
        <div class="container" style="padding-top: 20px;">
          <div class="row">
            <div class="col-sm-12 col-md-8 col-lg-8" style="padding-right: 20px;">
              <div class="row">
                <div class="col-md-12" style="font-size: 18px;">
                  <mat-checkbox class="clsGapping conentContent" formControlName="ContactConsent">I consent to be contacted by an
                   <br *ngIf="isMobileView"> onboarding specialist
                  </mat-checkbox>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12">
                  <mat-checkbox class="clsGapping conentContent" formControlName="HostingConsent">* I agree to <a href="/HostingTerms" (click)="openPolicyModal('hosting'); $event.preventDefault(); $event.stopPropagation()">the Hosting Terms and Conditions.</a>
                  </mat-checkbox>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12">
                  <mat-checkbox class="clsGapping conentContent" formControlName="PaymentPolicyConsent">* I agree to <a href="/PaymentPolicy" (click)="openPolicyModal('payment'); $event.preventDefault(); $event.stopPropagation()">the Payment Policy.</a>
                  </mat-checkbox>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12">
                  <mat-checkbox class="clsGapping conentContent" formControlName="ResolutionDisputePolicyConsent">* I agree to the <a href="/DisputePolicy" (click)="openPolicyModal('dispute'); $event.preventDefault(); $event.stopPropagation()">Resolution and Dispute Policy.</a>
                  </mat-checkbox>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12">
                  <mat-checkbox class="clsGapping conentContent" formControlName="ShippingPolicyConsent">* I agree to the <a href="/ShippingPolicy" (click)="openPolicyModal('shipping'); $event.preventDefault(); $event.stopPropagation()">Shipping Policy.</a>
                  </mat-checkbox>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12">
                  <mat-checkbox class="clsGapping conentContent" formControlName="PrivacyPolicyConsent">* I agree to the <a href="/Policies" (click)="openPolicyModal('privacy'); $event.preventDefault(); $event.stopPropagation()">Privacy Policy</a>
                  </mat-checkbox>
                </div>
              </div>
              <br>
              <div class="row align-right-end">
                <div class="col-sm-12 col-md-12 col-lg-12">
                  <button class="host-cta host-cta--ghost" type="button" (click)="stepper.previous()">Previous</button>
                  <button class="host-cta" type="button" (click)="SaveSignToHost()" [disabled]="personalDetails.invalid || businessDetails.invalid || marketDetails.invalid || consentDetails.invalid">Submit My Application</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
</div>

<ng-template #businessPhotoUpload>
  <div class="host-photo-upload" [class.host-photo-upload--filled]="!!businessImage">
    <button *ngIf="!businessImage" type="button" class="host-photo-upload__empty" (click)="businessPhotoInput.click()">
      <span class="host-photo-upload__icon" aria-hidden="true">
        <svg viewBox="0 0 64 64" fill="none">
          <rect x="6" y="16" width="42" height="34" rx="10" stroke="currentColor" stroke-width="3"/>
          <circle cx="27" cy="33" r="9" stroke="currentColor" stroke-width="3"/>
          <circle cx="27" cy="33" r="3.5" fill="currentColor"/>
          <path d="M18 16l3-6h8l3 6" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
          <circle cx="50" cy="16" r="11" fill="#FFCE1B"/>
          <path d="M50 11v10M45 16h10" stroke="#1c1008" stroke-width="2.4" stroke-linecap="round"/>
        </svg>
      </span>
      <span class="host-photo-upload__title">Add a business photo</span>
      <span class="host-photo-upload__hint">PNG or JPG Â· up to 5 MB</span>
    </button>

    <ng-container *ngIf="businessImage">
      <button type="button" class="host-photo-upload__preview" (click)="openPhotoPreview()">
        <img [src]="businessImage.image" alt="Uploaded business photo">
      </button>
      <div class="host-photo-upload__actions">
        <button type="button" class="host-photo-upload__action" (click)="openPhotoPreview()">Preview</button>
        <button type="button" class="host-photo-upload__action host-photo-upload__action--change" (click)="businessPhotoInput.click()">Change</button>
      </div>
    </ng-container>
    <input type="file" #businessPhotoInput accept="image/*" (change)="preview($event, 'BusinessImage')" hidden />
  </div>
  <mat-error *ngIf="businessImageValidate">Business image is required</mat-error>
</ng-template>

<div *ngIf="showPhotoPreview && businessImage" class="modal-overlay host-photo-lightbox" (click)="closePhotoPreview()">
  <div class="host-photo-lightbox__dialog" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Business photo</h2>
      <button class="close-btn" type="button" (click)="closePhotoPreview()">&times;</button>
    </div>
    <div class="host-photo-lightbox__body">
      <img [src]="businessImage.image" alt="Business photo full preview">
    </div>
    <div class="modal-footer">
      <button class="host-cta host-cta--plain" type="button" (click)="closePhotoPreview()">Close</button>
    </div>
  </div>
</div>

<div *ngIf="activePolicyModal" class="modal-overlay" (click)="closePolicyModal()">
  <div class="modal-content host-policy-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>{{ policyModalTitle }}</h2>
      <button class="close-btn" type="button" (click)="closePolicyModal()">&times;</button>
    </div>
    <div class="modal-body">
      <app-payment-policy *ngIf="activePolicyModal === 'payment'"></app-payment-policy>
      <app-shipping-policy *ngIf="activePolicyModal === 'shipping'"></app-shipping-policy>
      <app-dispute-policy *ngIf="activePolicyModal === 'dispute'"></app-dispute-policy>
      <app-hosting-terms *ngIf="activePolicyModal === 'hosting'"></app-hosting-terms>
      <app-policies *ngIf="activePolicyModal === 'privacy'"></app-policies>
    </div>
    <div class="modal-footer">
      <button class="host-cta host-cta--plain" type="button" (click)="closePolicyModal()">Close</button>
    </div>
  </div>
</div>
</div>
